import {TimelineMax, Sine} from 'gsap';
const Vue = require('vue');

Vue.component('search-link', {
    template: require('../../../../../../../components/templates/ui/search-link.pug'),
    props: {
        data: Object
    },
    data() {
        return {
            label: '',
            newLabel: null,
            _labelEl: null,
            _newLabelEl: null
        };
    },
    mounted() {
        this.label = this.data.label;

        this._labelEl = this.$el.querySelector('[data-initial]');
        this._newLabelEl = this.$el.querySelector('[data-new]');
        this._contEl = this.$el.querySelector('[data-container]');
        this._wrapEl = this.$el.querySelector('[data-wrap]');
    },
    watch: {
        data(to) {
            this.newLabel = to.label;
            let newBoundingBox = {width: 0};
            const prevBoundingBox = this._labelEl.getBoundingClientRect();
            const totalBoundingBox = this._contEl.getBoundingClientRect();

            const _getNewSize = el => {
                newBoundingBox = el.getBoundingClientRect();
            };

            const _fixSize = el => {
                el.style.width = totalBoundingBox.width + 'px';
                el.style.height = totalBoundingBox.height + 'px';
            };

            const _setNewSize = el => {
                el.style.width = totalBoundingBox.width + (newBoundingBox.width - prevBoundingBox.width) + 'px';
                el.style.height = totalBoundingBox.height + (newBoundingBox.height - prevBoundingBox.height) + 'px';
            };

            const _resetSize = el => {
                el.style.width = 'auto';
                el.style.height = 'auto';
            };

            const _resetLabel = obj => {
                obj.newLabel = obj.label;
                obj.label = '&nbsp;';
            };

            const _setNewLabel = obj => {
                obj.newLabel = obj.data.label;
            };

            const _setLabel = obj => {
                obj.label = obj.newLabel;
            };

            const _resetNew = obj => {
                obj.newLabel = null;
            };

            _resetNew;

            const tl = new TimelineMax();
            tl.set(this._newLabelEl, {opacity: 0});
            tl.call(_fixSize, [this._contEl]);
            tl.call(_getNewSize, [this._newLabelEl], null, '+=0.01');
            tl.call(_resetLabel, [this], null, '+=0.01');
            tl.set(this._labelEl, {opacity: 0}, null, '+=0.01');
            tl.set(this._newLabelEl, {opacity: 1}, null, '+=0.01');
            tl.to(this._newLabelEl, 0.15, {opacity: 0, ease: Sine.easeIn}, null, '+=0.01');
            tl.call(_setNewSize, [this._contEl], null, '+=0.01');
            tl.call(_setNewLabel, [this, this._newLabelEl], null, '+=0.6');
            tl.to(this._newLabelEl, 0.25, {opacity: 1, ease: Sine.easeout}, null, '+=0.01');
            tl.call(_setLabel, [this], null, '+=0.01');
            tl.set(this._newLabelEl, {opacity: 0}, null, '+=0.01');
            tl.set(this._labelEl, {opacity: 1});
            tl.call(_resetSize, [this._contEl]);
            // tl.call(_resetNew, [this]);
        }
    }
});
